import { OptionPrice } from '../../../lib/types/models/option-prices/option-price'
import { OptionPriceInput } from '../../../lib/types/models/option-prices/option-price-input'

export const optionPriceDefaultValuesMapping = (
  optionPrice?: OptionPrice
): OptionPriceInput | undefined => {
  if (!optionPrice) return
  return {
    countryIds: optionPrice.countries?.map((country) => country.id),
    formulaIds: optionPrice.formulas?.map((formula) => formula.id),
    minAge: optionPrice.minAge,
    maxAge: optionPrice.maxAge,
    appliedDurationsInDays: optionPrice.appliedDurationsInDays,
    periodIds: optionPrice.periods?.map((period) => period.id),
    price: optionPrice.price
  }
}
